module.exports = __webpack_public_path__ + "static/media/connect_app.876e86ed.svg";